import React, {Component} from 'react';
import AutoComplete from '../../../../itrust_common/components/others/AutoComplete';
import MedicalHistoryForm from './MedicalHistoryForm'

class MedicalHistoryFormWrapper extends Component{
  state = { isYes: this.props.records && this.props.records.length > 0 }

  componentDidUpdate(prevProps) {
    if (this.props.records && this.props.records.length > 0 && (!prevProps.records || prevProps.records.length === 0)) {
      if (!this.state.isYes) {
        this.setState({ isYes: true });
      }
    }
  }
  handleYes = () => this.setState({isYes: true})
  handleNo = () => {
    this.setState({isYes: false})
    if (this.props.records && this.props.records.length > 0) {
      this.props.handleDeleteAll(this.props.medicalHistoryCategory, (response) => {
        if (!response) {
          this.setState({isYes: true})
        }
      })
    }
  }
  
  render(){
  const {handleSubmit, belongsToId, name, records, klass, rpp, sort, direction, diseaseType, medicalHistoryCategory, hideAddButton} = this.props
    const {isYes} = this.state
    return (
      <div className="col-lg-6 col-md-12 mt-7">
        <div className="card border-0 shadow-sm">
          <div className="p-5 border-bottom border-light d-flex flex-row align-items-center justify-content-between">
            <h6>{name}</h6>
            <div>
              <div className="btn-group btn-group-toggle" data-toggle="buttons">
                <label onClick={this.handleNo} className={`btn btn-outline-primary ${!isYes ? 'active' : ''}`}>
                  <input type="radio" name={`options-${medicalHistoryCategory}`} autoComplete="off"/> No
                </label>

                <label onClick={this.handleYes} className={`btn btn-outline-primary ${isYes ? 'active' : ''}`}>
                  <input type="radio" name={`options-${medicalHistoryCategory}`} autoComplete="off"/> Yes
                </label>
              </div>
            </div>
          </div>
          {isYes &&
          <div className="card-body px-7">
            {isYes && <div className="border-bottom border-light pb-5">
              <AutoComplete key={medicalHistoryCategory} loadOnFocus={true} rpp={rpp} sort={sort} direction={direction} addNewSetting={medicalHistoryCategory} hideAddButton={hideAddButton}  textField="name" valueField="id" fieldName={medicalHistoryCategory} placeholder={`Search to add ${name}`} onSelect={(id) => handleSubmit({[belongsToId]: id, medical_history_category: medicalHistoryCategory})} klass={klass} otherFilters={{filter: {disease_type: diseaseType}}} wrapperClasses="w-100 position-relative"/>
            </div>}
            {records && records.map((record, index) =>
              <MedicalHistoryForm key={`medicalHistoryCategory${record.id}`} {...this.props} onSubmit={handleSubmit} form={`medicalHistoryCategory${record.id}`} initialValues={{...record}}/>
            )}
          </div>
          }
        </div>
      </div>
    );
  }
}

export default MedicalHistoryFormWrapper;